import JobList from './JobList'
import JobListAirmate from './JobListAirmate'

export default {
  JobList,
  JobListAirmate
}



// WEBPACK FOOTER //
// ./src/components/Onsite/index.js